if (!JSON.tryParse) {
	JSON.tryParse = function <T = object>(text: string, fallback?: T): T {
		try {
			return JSON.parse(text) as T;
		} catch {
			return fallback as T;
		}
	};
}
